import React from 'react';
import CategoryList from './category-list';
import Button from './button';

class ShopCategory extends React.Component {

	renderDescription(description) {
		return {__html: description};
	}
	render() {

		let category = this.props.data;
		let categories = this.props.data.subcategories;

		return (
			<React.Fragment>
				<div className="section__header">
					{this.props.headerText 
						? <h2 className="header--with-branding">{this.props.headerText }</h2>
						: <h2 className="header--with-branding">{category.name}</h2>
					}
				</div>
				<p dangerouslySetInnerHTML={this.renderDescription(category.description)} />				
				<CategoryList categories={categories}/>
				<Button cssClass="category__cta button--white" url={category.url} label={wp_core.i18n.cta_products} />
			</React.Fragment>



		);
	}
}	

export default ShopCategory;